export const NATIVE_APP_BRIDGE_CONSTANTS = {
    EVENT_NAME: 'eventName',
    INPUT_PARAMS: 'inputParams',
    CALLBACK: 'callback',
    GET_HEADERS_EVENT: 'getHeaders',
    GET_HEADERS_METHOD: 'method',
    GET_HEADERS_URL: 'url',
    GET_HEADERS_PARAMS: 'params',
    GET_HEADERS_CALLBACK: 'onGetHeaderSuccess',
    CLOSE_WEBVIEW: 'close',
    CLOSE_APP_TOOL_BAR: 'closeAppToolBar',
    ACQUSITION_EVENT: 'acquisitionStatus',
    ACQUSITION_SINUMBER: 'siNumber',
    ACQUSITION_TYPE: 'acquisitionType',
    ACQUSITION_STATUS: 'acquisitionStatus',
    SHOW_TOOLBAR: 'showToolbar',
    GET_SESSION_ID: 'getSessionID',
    GET_SESSION_ID_CALLBACK: 'onGetSessionIdSuccessIOS',
    GET_ANALYTICS_PARAMS_JSON: 'getAnalyticsParams',
    GET_ANALYTICS_PARAMS_JSON_CALLBACK: 'onGetAnalyticsParamsJsonSuccessIOS',
    MARK_MOENGAGE_EVENT: 'markMoengageEvent',
    GET_BARCODE_CALLBACK: 'getBarcodeResultCallback',
    GET_PROFILE_NAME: 'getProfileName',
    GET_PROFILE_NAME_CALLBACK: 'getProfileNameCallbackIOS',
    FETCH_CURRENT_LOCATION_CALLBACK: 'fetchCurrentLocationCallback',
    FETCH_CURRENT_LOCATION: 'fetchCurrentLocation',
    SEND_BRANCH_ANALYTICS: 'sendBranchAnalytics',
    EVENT: 'event',
    ATTRIBUTE_MAP: 'attributeMap',
    CUSTOM_BACKPRESS: 'customBackPress',
    CUSTOM_BACKPRESS_CALLBACK: 'customBackPressCallback',
    FETCH_CALL_STATUS_CALLBACK: 'callObserverCallback',
    REQUEST_PERMISSION_CALLBACK: 'requestPermissionCallback',
    OTP_JOURNEY_STARTED_CALLBACK: 'otpJourneyStartedCallback',
    GET_USER_PROFILE_NAME: 'getUserProfileName',
    GET_USER_PROFILE_NAME_CALLBACK: 'getUserProfileNameCallbackIOS',
};
export const NATIVE_APP_BRIDGE_ERRORS = {
    GENERIC: 'not running in webview',
    REQUEST_PERMISSION_FAILURE: 'requestPermission bridge failure',
    OTP_JOURNEY_STARTED_FAILURE: 'otpJourneyStarted bridge - read otp failure',
    OTP_JOURNEY_ENDED_FAILURE: 'otpJourneyEnded Bridge - close otp listener Failure',
};
export const REQ_SOURCE = 'myAirtelApp';
